/**
 * P13: drafts, the list of places and scroll positions live in the tab's session storage — always under the
 * signed-in account's id, and wiped on logout, on a lost session (401) and on login, so the next person at the
 * same computer sees nothing of the previous one (names of events, typed values).
 */

const ROOT = 'p13:';
let user: string | null = null;
const listeners = new Set<() => void>();

/** The storage key of `name` for the signed-in account. */
export const navKey = (name: string) => `${ROOT}${user ?? '-'}:${name}`;

/** The app frame tells who is signed in; a change of account starts the in-memory lists afresh. */
export function setNavUser(id: string | null) {
  if (id === user) return;
  user = id;
  for (const l of listeners) l();
}

export function onNavUserChange(listener: () => void) {
  listeners.add(listener);
}

/** Removes every P13 key (`keep`: except this account's own). */
export function purgeNavStorage(keep?: string) {
  try {
    const own = keep ? `${ROOT}${keep}:` : null;
    const doomed: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(ROOT) && (!own || !k.startsWith(own))) doomed.push(k);
    }
    for (const k of doomed) sessionStorage.removeItem(k);
  } catch {
    // storage blocked: nothing was kept there
  }
  if (!keep) for (const l of listeners) l(); // what is in memory goes too
}
